// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as UnitsGrid from "./UnitsGrid.bs.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as StatsConfig from "./StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as ListGridSelect from "./ListGridSelect.bs.js";
import * as InContextUnitOverview from "./InContextUnitOverview.bs.js";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Unit");
        }), undefined, (function (param, param$1, param$2) {
          var size = param$2.size;
          var setSelectedUnit = param$1.setSelectedUnit;
          var router = param$1.router;
          var aperture = param$1.aperture;
          var screenSize = param$1.screenSize;
          var unitId = param[0];
          return React.createElement("div", {
                      className: "flex font-roboto font-normal cursor-pointer items-center",
                      onClick: (function (param) {
                          if (ScreenAtom.isMobile(screenSize)) {
                            return router.push(Route.toString({
                                            TAG: /* Stats */0,
                                            _0: {
                                              TAG: /* Unit */4,
                                              unit: unitId,
                                              starLevel: undefined,
                                              aperture: aperture
                                            }
                                          }), undefined, undefined);
                          } else {
                            return Curry._1(setSelectedUnit, (function (param) {
                                          return unitId;
                                        }));
                          }
                        })
                    }, React.createElement(StatsTable2.ExpandIcon.make, {
                          onClick: (function (param) {
                              
                            })
                        }), React.createElement("div", {
                          className: "pr-[6px] flex-shrink-0"
                        }, React.createElement(UnitTooltip.make, {
                              unit: unitId,
                              children: React.createElement(UnitImage.make, {
                                    unitId: unitId,
                                    size: size === "md" ? 28 : (
                                        size === "sm" ? 24 : 32
                                      ),
                                    showName: false
                                  })
                            })), React.createElement("div", {
                          className: "truncate"
                        }, React.createElement(UnitName0.make, {
                              unit: unitId
                            })));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param$2.unitsT(param[0]);
        }), undefined, 177, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Cost");
        }), undefined, (function (param, param$1, param$2) {
          return String(Sd.unitTier(param[0]));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Sd.unitTier(param[0]);
        }), undefined, 62, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (param, param$1, param$2) {
          return (Global.f(param[1].count) / Global.f(param$1.totalEntries) * 8).toFixed(2) + " / 8";
        }), undefined, (function (param, param$1, param$2) {
          return T.humanReadableCount(param[1].count) + " games";
        }), undefined, (function (param, param$1, param$2) {
          return param[1].count;
        }), undefined, 100, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          return param[1].place.toFixed(2);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].place;
        }), undefined, 77, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].top4);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].top4;
        }), undefined, 75, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].won);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].won;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return "3★ " + param$1.t("Rate");
        }), undefined, (function (param, param$1, param$2) {
          var v = param[1];
          return Global.formatPct(undefined, Global.f(v.starCount) / Global.f(v.count)) + "%";
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          var v = param[1];
          return Global.f(v.starCount) / Global.f(v.count);
        }), undefined, 90, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return "3★ " + param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          var v = param[1].starPlace;
          if (v == null) {
            return "-";
          } else {
            return Global.toFixed(undefined, v);
          }
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].starPlace;
        }), undefined, 94, undefined, undefined)
];

function UnitsPage$List(Props) {
  var stats = Props.stats;
  var setSelectedUnit = Props.setSelectedUnit;
  var router = Router.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var context = React.useMemo((function () {
          return {
                  screenSize: screenSize,
                  aperture: aperture,
                  router: router,
                  setSelectedUnit: setSelectedUnit,
                  totalEntries: stats.totalEntries
                };
        }), [
        router,
        screenSize,
        stats,
        aperture,
        setSelectedUnit
      ]);
  var match = React.useState(function () {
        return "md";
      });
  var size = match[0];
  var sizeClass = size === "md" ? "md:w-[760px]" : (
      size === "sm" ? "md:w-[740px]" : "md:w-[800px]"
    );
  var keyFn = React.useCallback((function (v) {
          return v[0];
        }), []);
  return React.createElement("div", {
              className: "flex flex-col text-sm sm:text-base w-full " + sizeClass
            }, React.createElement(ContentSection.make, {
                  className: "py-3 px-0",
                  children: React.createElement(StatsTable2.make, {
                        size: size,
                        cols: cols,
                        data: Js_dict.entries(stats.units),
                        context: context,
                        keyFn: keyFn,
                        stickyColCount: 1,
                        defaultSortIdx: 2
                      })
                }));
}

var List = {
  cols: cols,
  make: UnitsPage$List
};

function UnitsPage(Props) {
  var statsData = Props.statsData;
  var router = Router.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var match = React.useState(function () {
        return false;
      });
  var isListMode = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setSelectedUnit = match$1[1];
  var selectedUnit = match$1[0];
  var aperture = ApertureCtx.useValue(undefined);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {
                  children: React.createElement(ListGridSelect.make, {
                        isListMode: isListMode,
                        setIsListMode: match[1]
                      })
                }), React.createElement(StatsConfig.Context.make, {
                  children: null
                }, isListMode ? React.createElement(UnitsPage$List, {
                        stats: statsData,
                        setSelectedUnit: setSelectedUnit
                      }) : React.createElement(UnitsGrid.make, {
                        totalEntries: statsData.totalEntries,
                        stats: statsData.units,
                        onUnitSelected: (function (unit) {
                            if (ScreenAtom.isMobile(screenSize)) {
                              return router.push(Route.toString({
                                              TAG: /* Stats */0,
                                              _0: {
                                                TAG: /* Unit */4,
                                                unit: unit,
                                                starLevel: undefined,
                                                aperture: aperture
                                              }
                                            }), undefined, undefined);
                            } else {
                              return Curry._1(setSelectedUnit, (function (param) {
                                            return unit;
                                          }));
                            }
                          })
                      }), selectedUnit !== undefined ? React.createElement(InContextUnitOverview.make, {
                        unitId: selectedUnit,
                        onClose: (function (param) {
                            return Curry._1(setSelectedUnit, (function (param) {
                                          
                                        }));
                          })
                      }) : null));
}

var make = UnitsPage;

export {
  List ,
  make ,
  
}
/* cols Not a pure module */
